var _title;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLlave2B(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 32,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none",
    className: "",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    className: ""
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M207.0000002,13.714844 L31.8125002,13.714844 C30.6718752,5.941406 24.0507812,0 15.984375199999999,0 C7.1562502,0 -5.828670879282072e-16,7.160156 -5.828670879282072e-16,16 C-5.828670879282072e-16,24.839844 7.1562502,32 15.984375199999999,32 C24.0507812,32 30.6718752,26.058594 31.8125002,18.285156 L207.0000002,18.285156 zM15.984375199999999,27.429688 C9.6679692,27.429688 4.566406199999999,22.324219 4.566406199999999,16 C4.566406199999999,9.675781 9.6679692,4.5703119999999995 15.984375199999999,4.5703119999999995 C22.3007812,4.5703119999999995 27.3984372,9.675781 27.3984372,16 C27.3984372,22.324219 22.3007812,27.429688 15.984375199999999,27.429688 zM15.984375199999999,27.429688 ",
    id: "svg_1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlave2B);
export default __webpack_public_path__ + "static/media/llave2b.d18e362d4b2f58023212a16cfe8561e2.svg";
export { ForwardRef as ReactComponent };